"use client";

import { useAppUpdate } from "@/hooks/use-app-update";

/**
 * Proactive "new version available" strip for long-lived tabs after a Netlify
 * deploy. Reactive chunk-load recovery in `chunk-load-error.ts` remains the
 * fallback when the user navigates before noticing this banner.
 */
export function AppUpdateBanner() {
  const { updateAvailable, dismiss, reload } = useAppUpdate();

  if (!updateAvailable) return null;

  return (
    <div
      role="status"
      className="sticky top-0 z-50 flex w-full flex-wrap items-center justify-center gap-x-3 gap-y-1 border-b border-border bg-muted/80 px-4 py-2 text-sm text-foreground backdrop-blur"
    >
      <span>A new version of Deliverables AI is available.</span>
      <span className="inline-flex items-center gap-2">
        <button
          type="button"
          onClick={reload}
          className="rounded-md bg-foreground px-2.5 py-1 text-xs font-medium text-background hover:opacity-90"
        >
          Reload now
        </button>
        <button
          type="button"
          onClick={dismiss}
          className="rounded-md px-2.5 py-1 text-xs font-medium text-subtle hover:text-foreground"
        >
          Not now
        </button>
      </span>
    </div>
  );
}
